/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_ErrorInputs */

const et_contact_error = /** @type {(inputs: Contact_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatmine ebaõnnestus. Proovige uuesti.`)
};

const en_contact_error = /** @type {(inputs: Contact_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending failed. Please try again.`)
};

/**
* | output |
* | --- |
* | "Sending failed. Please try again." |
*
* @param {Contact_ErrorInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_error = /** @type {((inputs?: Contact_ErrorInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_ErrorInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_error(inputs)
	return en_contact_error(inputs)
});